import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const clickToScrollUp = css`
  display: none;
  position: fixed;
  bottom: 1.5rem;
  right: 6.25rem;
  box-shadow: 0px 0px 24px 3px rgb(0 0 0 / 35%);

  &:hover {
    box-shadow: 0px 0px 24px 3px rgb(0 0 0 / 35%);
  }

  @media screen and (max-width: ${dimensions.phoneLargeMax}) {
    right: 1.25rem;
    bottom: 6.25rem;
  }
`;

export const overlay = css`
  z-index: 2;
`;

export const showClickToScrollUp = css`
  display: inline;
`;
